export const GenericTableTestIds = {
  tableContainer: 'table_container',
  genericTable: 'generic_table',
  checkboxRowSelect: 'checkbox_row_select',
  tableHeaderRow: 'table_header_row',
  tableNodataText: 'table_nodata_text',
  tablePaginator: 'table_paginator'
} as const;
